import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import api from '@services/api';
import dayjs from 'dayjs';
import { formatMessagesErrors } from '@utils/index';

// Components
import Accordion from '../Accordion';
import Input from '../Input';
import Button from '../Button';

// Style
import * as S from './style';

export const HeaderNewHarvest = () => {
  return <S.Title>Nova Safra</S.Title>;
};

const NewHarvest = ({
  width,
  handleClose,
  handleOpenModal,
  handleUpdateListOfHarvestsAfterAddOrEditHarvest,
}) => {
  const [open, setOpen] = useState(false);
  const [cultures, setCultures] = useState([]);
  const handleOpen = () => setOpen((prevState) => !prevState);
  const [isLoading, setIsLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: {
      description: '',
    },
    onSubmit: async (values) => {
      try {
        setIsLoading(true);

        const { data } = await api.post('/Harvest/Create', {
          descricao: values.description,
        });

        handleClose();
        handleOpenModal();
        handleUpdateListOfHarvestsAfterAddOrEditHarvest();

        enqueueSnackbar('Safra cadastrada com sucesso!', {
          variant: 'success',
        });
      } catch (error) {
        const messages = formatMessagesErrors(error);

        messages.forEach((message) => {
          enqueueSnackbar(message, {
            variant: 'error',
          });
        });
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <S.Wrapper onSubmit={formik.handleSubmit}>
      <Accordion
        keyAnimator="accordion_basics_informations"
        title="Informações Básicas"
        width={width}
        open={open}
        handleOpen={handleOpen}
      >
        <S.InputWrapper>
          <Input
            id="description"
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
            label="Descrição"
            width="100%"
            placeholder="Digite a descrição..."
            maxLength={5}
          />
        </S.InputWrapper>
      </Accordion>

      <Button
        width="100%"
        type="submit"
        borderHover="0"
        border="none"
        isLoading={isLoading}
      >
        Salvar
      </Button>
    </S.Wrapper>
  );
};

export default NewHarvest;
